/**
 * API error types — extracted from client.ts so that consumers (notably
 * `data/validation.ts`) can import them without triggering client.ts's
 * import-time VITE_API_BASE_URL check. This module is side-effect free.
 */

export class ApiError extends Error {
  readonly status: number;
  readonly statusText: string;
  readonly detail: string;
  /**
   * Structured response body when the server returned JSON, otherwise null.
   * Tharstern submit endpoints attach a FieldError list here on 400; see
   * `extractFieldErrors` in `data/validation.ts` for the canonical reader.
   */
  readonly body: unknown;

  constructor(
    status: number,
    statusText: string,
    detail: string,
    body: unknown = null,
  ) {
    super(`API error: ${status} ${statusText}${detail ? ` — ${detail}` : ""}`);
    this.name = "ApiError";
    this.status = status;
    this.statusText = statusText;
    this.detail = detail;
    this.body = body;
  }
}
